/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ICipDocumentsData } from './cip-documents.data';
import { ICipDocumentsProps } from './cip-documents.props.autogenerated';

export interface ICipDocumentsViewProps extends ICipDocumentsProps<ICipDocumentsData> {}

/**
 *
 * CipDocuments component
 * @extends {React.PureComponent<ICipDocumentsProps<ICipDocumentsData>>}
 */
class CipDocuments extends React.PureComponent<ICipDocumentsProps<ICipDocumentsData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default CipDocuments;
